import FilterDrawer from 'components/InstructorFormativeSubmissions/FilterDrawer';
import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import ErrorPage from 'pages/Error/404';
import Desktop from 'pages/InstructorFormativeSubmissions/desktop';
import Mobile from 'pages/InstructorFormativeSubmissions/mobile';
import { PageContext } from 'pages/InstructorFormativeSubmissions/PageProvider';
import Tablet from 'pages/InstructorFormativeSubmissions/tablet';
import { useContext } from 'react';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { isLoading, assignments, currentAssignment, studentSubmissions } = useApp();
    const { device } = useViewport();

    const contextProps = useContext(PageContext);

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...contextProps} />,
            tablet: <Tablet {...contextProps} />,
            desktop: <Desktop {...contextProps} />,
        }[device];
    };

    if (isLoading || !studentSubmissions) return <Loading />;

    if (assignments && !currentAssignment) return <ErrorPage />;

    return (
        <>
            {renderResponsiveLayout(device)}
            <FilterDrawer
                columns={contextProps.columns}
                sortState={contextProps.sortState}
                handleSetSortState={contextProps.handleSetSortState}
            />
        </>
    );
};

export default PageLayout;
